import React from 'react';


export default function Edo() {
    return (
        <>
            <p className={"content-header"}>Электронный документооборот</p>

            <p>На сайте реализована интеграция с системой электронного документооборота (ЭДО).</p>
            <br/>
            <p>В рамках электронного документооборота вы можете подписывать договоры с грузоотправителями.</p>
            <p>Кроме того вы можете подписывать документы, связанные с рейсом: заявку, доверенность, акт и счёт.</p>
            <br/>
            <p><b>Как начать обмен юридически значимыми документами через ЭДО</b></p>
            <p>Чтобы отправлять и получать документы (акты, счёта, договоры, заявки на рейсы, доверенности и др.) в электронном виде через наш сайт, выполните следующие шаги:</p>
            <ol>
                <li>
                    <b>Зарегистрируйтесь в системе ЭДО и настройте контрагентов </b>
                    <p>Перейдите на сайт ЭДО  и зарегистрируйте личный кабинет, если у вас его ещё нет.  </p>
                    <br/>
                    <b>Для Астрал.Доки:</b>
                    <p><a target="_blank" href="https://identity.astral.ru/Account/classic?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3Donecdocs%26scope%3Dopenid%2520offline_access%2520personarea_personal%2520personarea_contact%2520personarea_certificates%2520payment%2520editor%26response_type%3Dcode%26redirect_uri%3Dhttps%253A%252F%252F1cdocs.ru%252Fauth%252Fcb">
                        Личный кабинет.Доки
                    </a></p>
                    <p>Подробная инструкция по настройке доступна в официальной документации: <a target="_blank" href="https://astral.ru/help/doki/">https://astral.ru/help/doki/</a></p>
                    <br/>
                    <b>Для СБИС:</b>
                    <p><a target="_blank" href="https://online.sbis.ru/auth/?tab=register&agent=5200">
                        Личный кабинет СБИС
                    </a></p>
                    <p>Подробная инструкция по настройке доступна в официальной документации: <a target="_blank" href="https://saby-sbis.ru/lk-sbis-online-vhod">https://saby-sbis.ru/lk-sbis-online-vhod</a></p>
                    <br/>
                    <p>Добавьте в кабинет вашу организацию (юрлицо или ИП).  </p>
                    <p>В разделе «Мои контрагенты» укажите организации, с которыми вы планируете обмениваться документами. Для этого потребуется их ИНН и подтверждение связи с их стороны.</p>
                </li>
                <li>
                    <b>Подключите ЭДО в вашем личном кабинете на нашем сайте </b>
                    <p>Войдите в личный кабинет на нашем сайте.  </p>
                    <p>Перейдите в раздел: Кабинет → Настройки ЭДО → Электронный документооборот.  </p>
                    <img src="/img/edo/1.png" alt=""/>
                    <p>Авторизуйтесь, указав логин и пароль от вашего аккаунта ЭДО.  </p>
                    <img src="/img/edo/2.png" alt=""/>
                    <p>После успешной авторизации система автоматически свяжет вашу организацию на нашем сайте с вашим абонентом в ЭДО.
                        Наличие записи в колонке "Абонент ЭДО" сигнализирует о том, что всё прошло успешно.
                    </p>
                    <img src="/img/edo/3.png" alt=""/>
                </li>
                <li>
                    <b>Отправляйте документы контрагентам </b>
                    <p>После подключения вы сможете отправлять документы напрямую через наш сайт — они будут переданы в ЭДО.</p>
                    <img src="/img/edo/4.png" alt=""/>
                    <p>Если вы уже добавили контрагента (шаг 1), он автоматически появится в списке доступных получателей при отправке.</p>
                    <img src="/img/edo/5.png" alt=""/>
                    <p>При необходимости вы можете создать черновик без указания получателя, а позже — после добавления контрагента в ЭДО — завершить отправку и подписание.</p>
                    <img src="/img/edo/6.png" alt=""/>
                    <p>После успешной отправки документа, вам необходимо перейти по кнопке в ЭДО, подписать и отправить его в своём кабинете</p>
                    <img src="/img/edo/7.png" alt=""/>
                </li>
            </ol>
        </>

    )
}